import AttrField from '../Fields/AttrField';
import ColorField from '../Fields/ColorField';
import PixelField from '../Fields/PixelField';
import PaddingFields from '../Fields/PaddingFields';
import AttrLabel from '../Components/AttrLabel';
import PanelSection from '../Components/PanelSection';
import BorderFields from '../Fields/BorderFields';
import InlineLabel from '../Components/InlineLabel';
import HorizontalAlign from '../Fields/HorizontalAlign';
import { useTranslation } from 'react-i18next';
import FileField from '@SidePanel/Fields/FileField';
import { AttachFileRounded } from '@mui/icons-material';

function ButtonPanel() {
    const { t } = useTranslation();

    return (
        <>
            <PanelSection label={t('Button Details')} defaultExpanded>
                <AttrField
                    name="href"
                    Component={FileField}
                    sx={{ height: 100 }}
                    dropText={t('Drop or click to add files')}
                    Icon={AttachFileRounded}
                    accept="*"
                    multiple
                />
                <AttrLabel>{t('Button Link')}</AttrLabel>
                <AttrField
                    name="href"
                    placeholder="https://www.donbar.org"
                    dir="ltr"
                />
                <AttrLabel>{t('Button Color')}</AttrLabel>
                <AttrField
                    Component={ColorField}
                    name="style.backgroundColor"
                    placeholderSrc="theme.button.style.backgroundColor"
                />
                <AttrLabel>{t('Text Color')}</AttrLabel>
                <AttrField
                    Component={ColorField}
                    name="style.color"
                    placeholderSrc="theme.button.style.color"
                />
            </PanelSection>
            <PanelSection label={t('Size & Spacing')}>
                <AttrLabel>{t('Width')}</AttrLabel>
                <AttrField
                    Component={PixelField}
                    name="style.width"
                    placeholder={t('Auto')}
                />
                {/* <AttrLabel>{t('Height')}</AttrLabel>
                <AttrField
                    Component={PixelField}
                    name="style.height"
                    placeholder="height"
                /> */}
                <InlineLabel label={t('Button Alignment')}>
                    <HorizontalAlign
                        dir="ltr"
                        property="containerAttributes"
                        name="style.textAlign"
                    />
                </InlineLabel>
                <AttrLabel>{t('Button Padding')}</AttrLabel>
                <PaddingFields name="style.padding" />
            </PanelSection>
            <PanelSection label={t('Border')}>
                <BorderFields property="attributes.style" />
                {/* <Box display="flex" justifyContent="space-between"> */}
                {/* <AttrLabel>{t('Vertical Align')}</AttrLabel>
                <AttrField
                    Component={ButtonField}
                    name="style.alignContent"
                    exclusive
                    options={[
                        {
                            label: <AlignVerticalTopRounded />,
                            value: 'start',
                        },
                        {
                            label: <AlignVerticalCenterRounded />,
                            value: 'center',
                        },
                        {
                            label: <AlignVerticalBottomRounded />,
                            value: 'end',
                        },
                    ]}
                /> */}
                {/* </Box> */}
            </PanelSection>
            <PanelSection label={t('Block Styles')}>
                <AttrLabel>{t('Background Color')}</AttrLabel>
                <AttrField
                    Component={ColorField}
                    name="style.backgroundColor"
                    property="containerAttributes"
                    placeholder={t('Background Color')}
                />
                <AttrLabel>{t('Block Padding')}</AttrLabel>
                <PaddingFields
                    property="containerAttributes"
                    name="style.padding"
                />
            </PanelSection>
        </>
    );
}

export default ButtonPanel;
